import { useState, useEffect } from "react";
import offers from "../data/offers.json";
import "../style/LatestOffers.css";

const ITEMS_PER_PAGE = 10;

const imageMap = {
  "puma.webp": require("../assets/puma.webp"),
    "skechers.webp": require("../assets/skechers.webp"),
  "nykaa.png": require("../assets/nykaa.png"),
  "myntra.png": require("../assets/myntra.png"),
  "flipkart.png": require("../assets/flipkart.png"),
  "ajio.png": require("../assets/ajio.png"),
  "bookmyshow.png": require("../assets/bookmyshow.png"),
  "amazon.png": require("../assets/amazon.png"),
  "meesho.png": require("../assets/meesho.png"),
  "tira.png": require("../assets/tira.png"),
  "swiggy.png": require("../assets/swiggy.png"),
  "netflix.png": require("../assets/netflix.png"),
  "hotstar.png": require("../assets/hotstar.png"),
  "jiomart.png": require("../assets/jiomart.png"),
  "zepto.png": require("../assets/zepto.png"),
    "h&m.png": require("../assets/h&m.png"),
    "pvr.webp": require("../assets/pvr.webp"),
    "ixigo.webp": require("../assets/ixigo.webp"),
    "indigo.webp": require("../assets/indigo.webp"),
  "makemytrip.png": require("../assets/makemytrip.png"),
  "goibibo.png": require("../assets/goibibo.png"),
  "bewakoof.webp": require("../assets/bewakoof.webp"),
  "shein.webp": require("../assets/shein.webp"),
  "lakme.png": require("../assets/lakme.png"),
  "facescanada.webp": require("../assets/facescanada.webp"),
  "victorias.webp": require("../assets/victorias.webp"),
  "dotkey.webp": require("../assets/dotkey.webp"),
  "levis.png": require("../assets/levis.png"),
  "fossil.webp": require("../assets/fossil.webp"),
  "skybags.webp": require("../assets/skybags.webp"),
  "jockey.webp": require("../assets/jockey.webp"),
  "caratlane.png": require("../assets/caratlane.png"),
  "bebodywise.webp": require("../assets/bebodywise.webp"),
  "lenskart.png": require("../assets/lenskart.png"),
  "lavie.webp": require("../assets/lavie.webp"),
  "prada.webp": require("../assets/prada.webp"),
  "titan.webp": require("../assets/titan.webp"),
  "fastrack.webp": require("../assets/fastrack.webp"),
    "reebok.webp": require("../assets/reebok.webp"),
    "asics.webp": require("../assets/asics.webp"),
    "campus.webp": require("../assets/campus.webp"),
    "kazo.webp": require("../assets/kazo.webp"),
    "biba.png": require("../assets/biba.png"),
    "markandspencer.png": require("../assets/markandspencer.png"),
  "zomato.png": require("../assets/zomato.png"),
  "spotify.png": require("../assets/spotify.png"),
};

export default function LatestOffers() {
  const [activeTab, setActiveTab] = useState("latest");
  const [currentPage, setCurrentPage] = useState(1);

  // Reset page when tab changes
  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab]);

  const handleDealClick = (url) => {
    window.open(url, "_blank");
  };

  const handleCodeClick = (code, url) => {
    navigator.clipboard.writeText(code);
    window.open(url, "_blank");
    alert(`Coupon Code "${code}" copied!`);
  };

  // Filter offers by tab
  const filteredOffers =
    activeTab === "latest"
      ? offers
      : offers.filter((offer) => offer.category === activeTab);

  // Pagination calculations
  const totalPages = Math.ceil(filteredOffers.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginatedOffers = filteredOffers.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  return (
    <section className="offers-section">
      <div className="offers-header">
        <h2>Latest Offers</h2>

        <div className="offers-tabs">
          <button
            className={activeTab === "latest" ? "active" : ""}
            onClick={() => setActiveTab("latest")}
          >
            Show all
          </button>
          <button
            className={activeTab === "hottest" ? "active" : ""}
            onClick={() => setActiveTab("hottest")}
          >
            Hottest
          </button>
          <button
            className={activeTab === "popular" ? "active" : ""}
            onClick={() => setActiveTab("popular")}
          >
            Popular
          </button>
        </div>
      </div>

      <div className="offers-list">
        {paginatedOffers.length === 0 ? (
          <p className="no-data">No offers available.</p>
        ) : (
          paginatedOffers.map((offer) => (
            <div className="offer-card" key={offer.id}>
              <div className="offer-left">
<img
  src={imageMap[offer.logo]}
  alt={`${offer.brand} coupon logo`}
  loading="lazy"
/>              </div>

              <div className="offer-middle">
                <h3>{offer.title}</h3>
                <p>{offer.description}</p>
              </div>

              <div className="offer-right">
                {offer.type === "deal" ? (
                  <button
                    className="btn-deal"
                    onClick={() => handleDealClick(offer.link)}
                  >
                    GET DEAL
                  </button>
                ) : (
                  <button
                    className="btn-code"
                    onClick={() =>
                      handleCodeClick(offer.code, offer.link)
                    }
                  >
                    GET CODE
                  </button>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            Prev
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1).map(
            (page) => (
              <button
                key={page}
                className={page === currentPage ? "active" : ""}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            )
          )}

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            Next
          </button>
        </div>
      )}
    </section>
  );
}
